// Gate de horario para badge "LLEGA HOY".
// Añade la clase `mismo-dia-activo` en <html> si es día hábil y antes de las 11:00
// (hora Chile). El CSS muestra los badges solo cuando esa clase existe.
//
// Depende de window.EstelarBusinessDay (estelar-business-day.js).
//
// Estrategia para load-more / fetch: la clase va en <html>, no por elemento.
// Las tarjetas inyectadas después del DOMContentLoaded heredan el estado
// automáticamente sin necesidad de re-ejecutar el gate.

(function () {
  if (typeof window.EstelarBusinessDay === 'undefined') return;

  function getChileNow() {
    var now = new Date();
    var parts = {};
    // formatToParts es más robusto que parsear toLocaleString()
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Santiago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(now).forEach(function (p) {
      parts[p.type] = p.value;
    });
    return {
      date: new Date(+parts.year, +parts.month - 1, +parts.day),
      hour: +parts.hour === 24 ? 0 : +parts.hour, // normaliza medianoche
    };
  }

  function evaluate() {
    var chile = getChileNow();
    if (window.EstelarBusinessDay.isBusinessDay(chile.date) && chile.hour < 11) {
      document.documentElement.classList.add('mismo-dia-activo');
    }
  }

  // Ejecutar tan pronto como el DOM esté listo.
  // La clase en <html> ya existe antes de que se pinten las tarjetas.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
})();
